<template>
  <vs-sidebar
    click-not-close
    position-right
    spacer
    parent="body"
    color="primary"
    default-index="1"
    id="schedules-view-sidebar"
    v-model="isSidebarActiveLocal"
    class="add-new-data-sidebar items-no-padding"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>ATUALIZAR AGENDAMENTO</h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      />
    </div>
    <vs-divider class="mb-0"/>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl" >
      <div class="p-6">
        <div class="mb-5">
          <p class="vs-input--label">Data de envio:</p>
          <flat-pickr
              :config="configDatePicker"
              placeholder="Data de Envio"
              v-model="schedule.newDate"
              class="w-full"
              name="data"
              v-validate="'required'"
          />
          <span class="text-danger text-sm" v-show="errors.has('data')" >
            {{ errors.first('data') }}
          </span>
        </div>

        <div class="mb-5">
          <p class="vs-input--label">Horário do envio:</p>
          <flat-pickr
              class=" w-full"
              name="hora"
              v-validate="'required'"
              v-model="schedule.newTime"
              placeholder="Momento de Envio"
              :config="configdateTimePicker"
          />
          <span class="text-danger text-sm" v-show="errors.has('hora')">
            {{ errors.first('hora') }}
          </span>
        </div>

        <div class="mb-5" v-if="instance && instance.is_official">
          <div class="flex flex-row w-full">
            <vs-input label="Nome do Template selecionado" class="w-full" :value="schedule.messageTemplateName" :disabled="true" />

            <div class="hover:text-primary stroke-current mt-4 p-2" @click.stop="chooseSelectTemplate()">
              <feather-icon class="flex flex-center items-center" icon="EditIcon" svgClasses="w-5 h-5" />
              <label class="text-sm">Editar</label>
            </div>
          </div>

          <select-message-template
              title=""
              :itemsPerPage="4"
              :instance="instance"
              v-if="openSelectTemplate"
              ref="select-message-template"
              :viewCollumns="['name', 'status']"
              @on-select-template="selectTemplate"
          ></select-message-template>
        </div>
        <div class="mb-5" v-else>
          <p class="vs-input--label">Texto a ser enviado:</p>
          <vs-textarea
              class="w-full"
              name="mensagem"
              v-validate="'required'"
              v-model="schedule.newText"
          />
          <span class="text-danger text-sm" v-show="errors.has('mensagem')">
              {{ errors.first('mensagem') }}
          </span>
        </div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" :disabled="!isFormValid" @click="updateContactSchedule">
        Salvar
      </vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">
        Cancelar
      </vs-button>
    </div>
  </vs-sidebar>
</template>

<script>

import { updateContactSchedule } from "@/http/requests/contactSchedule";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import selectMessageTemplate from "@/components/meta/SelectMessageTemplate.vue";

import flatPickr from 'vue-flatpickr-component';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import 'flatpickr/dist/flatpickr.css';
import { getTimeZone } from "../../utils";

export default {
  name: 'schedules-view-sidebar',
  components: {
    flatPickr,
    VuePerfectScrollbar,
    selectMessageTemplate
  },
  provide() {
    return {
      $validator: this.$validator,
    }
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    schedule: {
      type: Object,
      required: false,
      default: () => {
        return {
          data: {},
          id: null,
          newText: '',
          newDate: '',
          newTime: '',
          targetId: null,
          messageTemplateName: null,
        }
      }
    }
  },
  data() {
    return {
      settings: {
        wheelSpeed: .60,
        maxScrollbarLength: 60
      },
      configDatePicker: {
        enableTime: false,
        noCalendar: false,
        time_24hr: true,
        dateFormat: 'd/m/Y'
      },
      configdateTimePicker: {
        enableTime: true,
        noCalendar: true,
        time_24hr: true
      },
      templateMessage: {
        selectedTemplate: [],
        templateParameters: []
      },
      openSelectTemplate: false,
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() { return this.isSidebarActive },
      set( val ) {
        if(!val) { this.$emit('closeSidebar') }
      }
    },
    isFormValid() {
      return !this.errors.any()
    },
    instance(){
      return this.schedule.data.instance ? this.schedule.data.instance : null
    }
  },
  methods: {
    chooseSelectTemplate(){
      this.openSelectTemplate = !this.openSelectTemplate
    },
    async validade(){
      let main = await this.$validator.validateAll().then(result => {
        return result;
      });

      let childs = this.$children.map( async child => {
        return await child.$validator.validateAll();
      });

      childs = await Promise.all(childs).then( results => { return results; })
      return main && !childs.includes(false);
    },
    selectTemplate(args){
      this.templateMessage.selectedTemplate = args.selectedTemplate
      this.templateMessage.templateParameters = args.templateParameters
    },
    initValues() {
      this.openSelectTemplate = false;
      this.templateMessage = {
        selectedTemplate: [],
        templateParameters: []
      };
      this.schedule = {
        data: {},
        id: null,
        newText: '',
        newDate: '',
        newTime: '',
        targetId: null,
        messageTemplateName: null,
      }
    },
    async updateContactSchedule() {
      if (await this.validade()) {
        const date = new Date();
        const splitNewDate = this.schedule.newDate.split('/');
        const triggering_date = splitNewDate[2] + '-' + splitNewDate[1] + '-' + splitNewDate[0] + ' ' + getTimeZone(this.schedule.newTime, 'schedules-update', true);
        const data = {
          targetId: this.schedule.targetId,
          text_message: this.schedule.newText,
          triggering_date: triggering_date,
          message_template_name: this.templateMessage.selectedTemplate.name,
          message_template_id: this.templateMessage.selectedTemplate.meta_id,
          official_params: this.templateMessage.templateParameters,
        }

        if (
            (
              this.schedule.newTime < date.toString().split(' ')[4] &&
              date.toISOString().split('T')[0] === triggering_date.split(' ')[0]
            ) || ( new Date(triggering_date) < date )
        ) {
          return this.$vs.notify({
            color: 'danger',
            title: 'Aviso',
            text: 'Você não pode agendar mensagens para horários passados!'
          });
        }

        updateContactSchedule(data).then(() => {
          this.$emit('closeSidebar')
          this.initValues();

          return this.$vs.notify({
            color: 'success',
            title: 'Sucesso',
            text: 'O agendamento foi atualizado com sucesso!'
          });
        }).catch((error) => {
          console.log(error)
          return this.$vs.notify({
            color: 'danger',
            title: 'Erro',
            text: 'Houve algum erro ao atualizar agendamento!'
          });
        });
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }

    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .scroll-area--data-list-add-new {
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
  }
</style>
